import { useEffect, useContext, useState, useRef } from 'react';
import axiosConn from '../../axiosConn';
import { AuthContext } from '../../context/AuthContext';
import { useConfettiText } from '../../hooks/useConfettiText';
import useMobileView from '../../hooks/useMobileView';
import RewardCard from '../rewardCard/RewardCard';

const MESSAGE_PARTICLE_COUNT = 1000;

const DailyVisit = () => {
  const [hasCheckedIn, setHasCheckedIn] = useState(false);
  const { player } = useContext(AuthContext);

  const playerId = player.data.player?.playerId;
  const lastPingKey = `lastDailyVisit_${playerId}`;
  const lastPing = localStorage.getItem(lastPingKey);

  const [rewardData, setRewardData] = useState(null);
  const dailyVisitRef = useRef(null);
  const mobileView = useMobileView();

  const [showConfettiText, ConfettiTextComponent] = useConfettiText(
    dailyVisitRef,
    mobileView,
    '+10 JGK Win!',
    MESSAGE_PARTICLE_COUNT,
    'dailyVisit',
  );
  // console.log('Last daily visit:', lastPing);
  const today = new Date().toISOString().split('T')[0];

  useEffect(() => {
    if (lastPing === today) {
      setHasCheckedIn(true);
      // console.log('Already checked in today:', lastPing);
      return;
    } else {
      // console.log('Not checked in today, proceeding with daily visit:', today);
      setHasCheckedIn(false);
    }

    axiosConn
      .get('/players/daily-visit', {
        headers: {
          Authorization: `Bearer ${player.token}`,
        },
      })
      .then((res) => {
        // console.log('Daily visit recorded:', res.data);
        localStorage.setItem(lastPingKey, today);
        setHasCheckedIn(true);
        setRewardData(res.data.data); // Contains loginStreak, xpEarned, jgkEarned
        showConfettiText(); // 👈 trigger confetti
        // console.log('DailyVisit Recorded: Reward data:', res.data.data);
      })
      .catch((err) => {
        console.error('Daily visit failed:', err);
      });
  }, [player.token, today]);

  // console.log(
  //   'Has checked in:',
  //   hasCheckedIn,
  //   'Reward data:',
  //   rewardData,
  //   'Last ping:',
  //   lastPing,
  //   lastPing !== today,
  // );
  useEffect(() => {
    showConfettiText(); // Trigger confetti text effect
    //   console.log('dailyVisitRef:', dailyVisitRef.current);
  }, []);

  // console.log(
  //   'DailyVisit: lastPing != today:',
  //   lastPing !== today,
  //   'hasCheckedIn:',
  //   hasCheckedIn,
  //   'rewardData:',
  //   rewardData,
  // );
  return (
    // lastPing !== today &&
    hasCheckedIn &&
    rewardData && (
      <>
        <div
          ref={dailyVisitRef}
          style={{
            position: 'relative',
            width: '100%',
            height: '1px', // or minimal height
            marginBottom: '8px',
          }}
        ></div>
        <ConfettiTextComponent />

        <RewardCard
          title="✅ Daily Visit Recorded!"
          showConfetti={true}
          category="dailyVisit"
          rewards={{
            xp: rewardData?.xpEarned,
            jgk: rewardData?.jgkEarned,
            streak: rewardData?.loginStreak,
            badge: 'Daily Visitor',
          }}
        />
      </>
    )
  );
};

export default DailyVisit;
